// extracted by mini-css-extract-plugin
export default {"notification-wrapper":"hDH4h"};